import { useEffect, useState, useContext, useRef } from "react";
import { Image, Button, Row, Col, Spinner, Form, Modal } from "react-bootstrap";
import { UserInfo } from "../helper/Context";
import UploadResultDisplay from "./UploadResultDisplay";
import {
  APIWebVisualization,
  APIFileVisualization,
  APISearchVisuals
} from "../helper/APIFunctions";
import { prepBrandProfileList } from "../helper/Utils";
import {
  pdbValidator,
  pubchemValidator,
  snorkleValidator,
} from "../helper/WebResourceValidators";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faImage as imageIcon,
  faArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import SearchForm from "./SearchForm";


const getMaxNum = (type, extended) => {
    return 20;
  };
  const getButtonText = (status, isOwn) => {
    switch (status) {
      case "complete":
        return <>Visual Added!</>
      case "error":
        return <>There was an error.</>
      default:
        return isOwn ?<>Create Copy</> : <>Add to My Visuals</>
    }
  }
  
  const VisItem = (props) => {
    const [uploadStatus, setUploadStatus] = useState({});
    const [isHover, setIsHover] = useState(false);
    const [expandText, setExpandText] = useState(false);
    const url = props.url;
    return (
      <div
        className={`border border-secondary m-2 ${props.lightTheme ? 'bg-light text-dark' : 'bg-dark text-white'}`}
        style={{ position: "relative", width: "15vw", minWidth: "20rem", minHeight: "15rem" }}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => {setIsHover(false); setExpandText(false)}}
        onFocus={() => setIsHover(true)}
        onBlur={() => {setIsHover(false);setExpandText(false)}}
        tabIndex={-1}
      >
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, textAlign: "center", textJustify: "center", zIndex: 10 }}
          className={uploadStatus && uploadStatus.state === "uploading" ? "blockout active" : "blockout"}>
          <h3 style={{ position: "absolute", opacity: 1., top: "50%", left: "50%", transform: "translate(-50%,-50%)" }}>
            Creating Visual
            <br />
            <Spinner
              animation="border"
              role="uploading"
              className="text-secondary"
            >
              <span className="visually-hidden">Uploading...</span>
            </Spinner></h3>
        </div>
        <div style={{ position: "absolute", backgroundColor: "rgba(0,0,0,0.75)", color: "#eaeaea", bottom: 0, left: 0, right: 0, textAlign: "center", zIndex: 1 }}>
          {props.title}
        </div>
        <img
          src={props.imgSrc || "https://static.thenounproject.com/png/2932881-200.png"}
          alt={props.title}
          style={{ position: "absolute", left: "0", right: "0", top: "0", bottom: "0", width: "100%", height: "100%", zIndex: 0, objectFit: "cover", filter: props.blurImage ? "blur(2px) hue-rotate(30deg) grayscale(20%)" : "initial" }}
        />
        {props.icon ? (<div style={{ position: "absolute", top: 0, left: 0, zIndex: 3, color: "#ffffff", backgroundColor: "rgba(0,0,0,0.66)", width: "2.828rem", height: "2.828rem", padding: "0.414rem", borderRadius: "2.828rem" }}>{
          props.icon == imageIcon ? (
            <FontAwesomeIcon
              icon={props.icon}
              title={props.iconTitle}
              size="2xl"
            />
          ) : (
            <Image
              src={props.icon}
              style={{
                width: "100%",
                maxWidth: "3em",
                filter: "invert(100%)",
              }}
              title={props.iconTitle}
            />
          )}</div>
        ) : null}
        <div className={isHover ? "blockout active" : "blockout"} style={{
          zIndex: "5 !importatnt", height: "100%", position: "relative", display: "flex", justifyContent: "space-between", flexDirection: "column"
        }}>
          <div><b>{props.title}</b></div>
          {props.description ? (
            <div style={{ overflowWrap: "anywhere" }} className={isHover && expandText ? "": "clamp-lines-search-result"} onClick={() => setExpandText(!expandText)}>
              {props.description}
            </div>
          ) : null}
          <div className="text-center" style={{ bottom: 0 }}>
            {props.addFcn ? (
            <Button onClick={() => {
              props?.setIsUploading?.(true);
              setUploadStatus({ state: "uploading" });
              props.addFcn(() => setUploadStatus({ state: "complete" }), () => { setUploadStatus({ state: "error" }) });
            }} disabled={props.disabled || (uploadStatus && uploadStatus.state && uploadStatus.state != "error")}>
              {props.buttonText || getButtonText(uploadStatus.state || "", props.isOwner)}
            </Button>
            ) : (url ? <a href={url} target="_blank" rel="noopener noreferrer"><Button>View In New Tab</Button></a> : null)}
          </div>
        </div>  
      </div>
    );
  };
  
  const getPDBData = (ids, successCB, failureCB) => {
    const queryString = `{entries(entry_ids: ${JSON.stringify(
      ids
    )}) {rcsb_id struct{title}}}`;
    const url =
      "https://data.rcsb.org/graphql?query=" + encodeURIComponent(queryString);
    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (response) => {
        const body = await response.json();
        if (response.ok) {
          successCB(
            body.data.entries.map((entry) => {
              return {
                id: entry.rcsb_id,
                title: entry.struct.title,
                description: `RCSB Protein Data Bank structure ${entry.rcsb_id}`,
                type: "pdb",
                rating: 1,
              };
            })
          );
        } else {
          failureCB(body);
        }
      })
      .catch((reason) => {
        failureCB(reason);
      });
  };
  
  const getPubchemInfo = (cids, successCB, failureCB) => {
    const descUrl = `https://pubchem.ncbi.nlm.nih.gov/rest/pug/compound/cid/${cids.join()}/description/json`;
    fetch(descUrl, {
      method: "GET",
    })
      .then(async (response) => {
        if (!response.ok) {
          failureCB("Unable to fetch results");
        }
        const body = await response.json();
        if (
          !body.InformationList ||
          !body.InformationList.Information ||
          !body.InformationList.Information.length
        ) {
          failureCB("No results");
          return;
        }
        let content = {};
        body.InformationList.Information.forEach((v) => {
          if (!content[v.CID]) {
            content[v.CID] = {
              id: v.CID,
              description: `PubChem compound ${v.CID}`,
              type: "pubchem",
              rating: 1,
            };
          }
          content[v.CID].title = v.Title || content[v.CID].title;
          content[v.CID].description = v.Description
            ? v.Description + "\n\n" + content[v.CID].description
            : content[v.CID].description;
        });
        successCB(cids.map((cid) => content[cid]));
      })
      .catch((e) => failureCB(e));
  };
  
  const SearchResults = (props) => {
    const [rawSources, setRawSources] = useState({ res: [], ready: false });
    const [sources, setSources] = useState({ res: [], ready: false });
    const [uploadCount, setUploadCount] = useState(0);
    const [uploadResult, setUploadResult] = useState([]);
    const [modalInfo, setModalInfo] = useState(null);
    const [blurb, setBlurb] = useState(null);
    const [showImages, setShowImages] = useState(false);
    const [extended, setExtended] = useState(false);
    const [forceExtended, setForceExtended] = useState(false);
    const [previewVisualInfo, setPreviewVisualInfo] = useState(null);
    const [loadingCount, setLoadingCount] = useState(0);
    const [isLocallyUploading, setIsLocallyUploading] = useState(false);
    const searchResultsRef = useRef(null);

    // Lock / unlock body scroll while a visual is being created
    useEffect(() => {
      if (isLocallyUploading) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
      return () => { document.body.style.overflow = ''; };
    }, [isLocallyUploading]);

    // Combined setter: tracks state locally AND notifies parent
    const handleSetIsUploading = (val) => {
      setIsLocallyUploading(val);
      props.setIsUploading?.(val);
    };
  
    useEffect(() => {
      if (!rawSources.ready) {
        setSources({ res: [], ready: false });
        return;
      }
      const fs = rawSources.res.every((s) => s.type == "images");
      const out_arr = [];
      const type_count = {};
      const seen = new Set();
      for (const item of rawSources.res) {
        const url = item.url || item.visualization_url || item.visual_url;
        if(item.type === "snorkle" && !item.id && url) {
          item.id = snorkleValidator(url);
        }
        // Use a combination of type and a unique identifier (id, url, or image) for the key.
        const uniqueIdentifier = item.id ?? item.url ?? item.image ?? item.layerName??item.visualization_url ?? item.ra?.toString()+";"+item.dec?.toString();
        if (!uniqueIdentifier) {
          continue;
        }
        const itemKey = `${item.type}-${uniqueIdentifier}`;

        if (
          !seen.has(itemKey) &&
          getMaxNum(item.type, extended || fs) > (type_count[item.type] || 0) &&
          (item.rating > 0.75 || (item.type.includes("snorkle")) && (item.rating > 0.66))
        ) {
          out_arr.push(item);
          seen.add(itemKey);
          type_count[item.type] = (type_count[item.type] || 0) + 1;
        }
      }
      setForceExtended(fs);
      setSources({ res: out_arr, ready: true });
    }, [rawSources, extended]);
  
    const webUploadSuccess = (body) => {
      setUploadResult(arr => [...arr, {
        success: true,
        payload: body,
      }]);
      setUploadCount(t => t - 1);
      handleSetIsUploading(false);
      if (searchResultsRef.current) {
        searchResultsRef.current.scrollIntoView({ behavior: 'smooth' });
      }
      if (props.onVisualAdded) {
        props.onVisualAdded(body);
      }
    };
    const webUploadFailure = (body) => {
      let err_msg = "";
      if (body.error) {
        err_msg = body.error;
      } else {
        err_msg = body.toString();
      }
      setUploadResult(arr => [...arr, {
        success: false,
        payload: err_msg,
      }]);
      setUploadCount(t => t - 1);
      handleSetIsUploading(false);
    };
  
    const getAddFcn = (item) => {
      const type = item.type;
      if (type === "pdb") {
        return (successCB, failureCB) => {
          setUploadCount(t => t + 1);
          APIWebVisualization(
            item.id,
            "pdb",
            item.title,
            item.description,
            (res) => {
              webUploadSuccess(res);
              successCB(res);
            },
            (res) => {
              webUploadFailure(res);
              failureCB(res);
            },
            props.isOrg
          );
        };
      } else if (type === "pubchem") {
        return (successCB, failureCB) => {
          setUploadCount(t => t + 1);
          APIWebVisualization(
            item.id,
            "pubchem",
            item.title,
            item.description,
            (res) => {
              webUploadSuccess(res);
              successCB(res);
            },
            (res) => {
              webUploadFailure(res);
              failureCB(res);
            },
            props.isOrg
          );
        };
      } else if (type === "images") {
        return (successCB, failureCB) => {
          setUploadCount(t => t + 1);
          APIFileVisualization(
            item.url || item.image,
            item.title,
            item.description,
            (res) => {
              webUploadSuccess(res);
              successCB(res);
            },
            (res) => {
              webUploadFailure(res);
              failureCB(res);
            },
            false,
            { isSimple: true }
          );
        };
      }
      else if (type === "anatomy-set") {
        return (successCB, failureCB) => {
          setUploadCount(t => t + 1);
          APIWebVisualization(
            item.id,
            "anatomy_set",
            item.title,
            item.description,
            (res) => {
              webUploadSuccess(res);
              successCB(res);
            },
            (res) => {
              webUploadFailure(res);
              failureCB(res);
            },
          );
        };
      }
      else if (type === "astronomy") {
        return (successCB, failureCB) => {
          setUploadCount(t => t + 1);
          APIWebVisualization(
            item.layerName ?? "sky",
            "astro",
            item.title,
            item.description, 
            (res) => {
              webUploadSuccess(res);
              successCB(res);
            },
            (res) => {
              webUploadFailure(res);
              failureCB(res);
            },
            false,
            { ra: item.ra, dec: item.dec, angularFov: item.angularFov }
          );
        };
      }
      else if (type === "snorkle" || type === "models") {
        return (successCB, failureCB) => {
          setUploadCount(t => t + 1);
          APIWebVisualization(
            item.id,
            type === "snorkle" ? "snorkle" : "sketchfab",
            item.title,
            item.description,
            (res) => {
              webUploadSuccess(res);
              successCB(res);
            },
            (res) => {
              webUploadFailure(res);
              failureCB(res);
            },
            props.isOrg
          );
        };
      }
    };
  
    const getThumbnail = (item) => {
        if (item.thumbnail) return item.thumbnail;
        if(item.type === 'images') return item.url;
        if(item.type === 'models') return item.thumbnail;
        if(item.type === 'astronomy') return item.image ||  "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Webb%27s_First_Deep_Field.jpg/587px-Webb%27s_First_Deep_Field.jpg";
        if(item.type === 'snorkle') return item.thumbnail;
        if(item.type === 'pdb') return `https://cdn.rcsb.org/images/structures/${item.id.toLowerCase()}_assembly-1.jpeg`;
        if(item.type === 'pubchem') return `https://pubchem.ncbi.nlm.nih.gov/rest/pug/compound/cid/${item.id}/PNG?record_type=3d`;
        if(item.type === 'anatomy-set') return "/snorkle_vis_thumbnails/anatomy_set_thumb.png";
        return null;
    }

    const getIcon = (item) => {
        if(item.type === 'images') return imageIcon;
        if(item.type === 'models') return '/snorkle_vis_thumbnails/3d_vis_icon.png';
        if(item.type === 'astronomy') return '/snorkle_vis_thumbnails/astro_vis_icon.png';
        if(item.type === 'snorkle' && item.vis_type === 'simple_image') return imageIcon;
        if(item.type === 'snorkle') return '/snorkle_vis_thumbnails/snorkle_vis_icon.png';
        if(item.type === 'anatomy-set') return '/snorkle_vis_thumbnails/snorkle_vis_icon.png';
        if(item.type === 'pdb') return '/snorkle_vis_thumbnails/protein_vis_icon.png';
        if(item.type === 'pubchem') return '/snorkle_vis_thumbnails/chem_vis_icon.png';
    }

    const getIconTitle = (item) => {
        if(item.type === 'images') return 'This is a standard image';
        if(item.type === 'models') return 'This is a 3D model from Sketchfab';
        if(item.type === 'astronomy') return 'This is an astronomical image';
        if(item.type === 'snorkle') return 'This is a Snorkle visual';
        if(item.type === 'anatomy-set') return 'This is a simple human anatomy viewer';
        if(item.type === 'pdb') return 'This is a PDB structure';
        if(item.type === 'pubchem') return 'This is a PubChem compound';
    }


    const snorkle = (term) => {
      setLoadingCount(c => c + 1);
      APISearchVisuals(
        term,
        (res) => {
          if (res) {
            if (res.blurb) {
              setBlurb(res.blurb);
            }
            if (Array.isArray(res.sources)) {
              setRawSources(old => ({ res: [...old.res, ...res.sources], ready: true }));
            }
          }
          setLoadingCount(c => c - 1);
        },
        (err) => {
            setLoadingCount(c => c - 1);
        },
        props.isOrg
      );
    };
  
    const pdb = (term) => {
      let pdbIds = pdbValidator(term);
      if (pdbIds) {
        if (!Array.isArray(pdbIds)) {
          pdbIds = [pdbIds];
        }
        if (pdbIds.length > 0) {
            setLoadingCount(c => c + 1);
          getPDBData(
            pdbIds,
            (res) => {
              if (res && Array.isArray(res)) {
                setRawSources(old => ({ res: [...old.res, ...res], ready: true }));
              }
              setLoadingCount(c => c - 1);
            },
            (err) => {
              setLoadingCount(c => c - 1);
            }
          );
        }
      }
    };
  
    const pubchem = (term) => {
      let cids = pubchemValidator(term);
      if (cids) {
        if (!Array.isArray(cids)) {
          cids = [cids];
        }
        if (cids.length > 0) {
            setLoadingCount(c => c + 1);
          getPubchemInfo(
            cids,
            (res) => {
              if (res && Array.isArray(res)) {
                setRawSources((prev) => {
                  return { res: [...prev.res, ...res], ready: true };
                });
              }
              setLoadingCount(c => c - 1);
            },
            (err) => {
              setLoadingCount(c => c - 1);
            }
          );
        }
      }
    };
  
  
    useEffect(() => {
      setRawSources({ res: [], ready: false });
      setBlurb(null);
      setLoadingCount(0);
      if (props.searchTerm) {
        snorkle(props.searchTerm);
        pdb(props.searchTerm);
        pubchem(props.searchTerm);
      }
    }, [props.searchTerm]);
  
    if (loadingCount > 0) {
        return (
            <div className="d-flex justify-content-center mt-5">
                <Spinner animation="border" role="status" className={props.lightTheme ? "text-dark" : "text-light"}>
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }

    return (
      <div className={props.lightTheme ? 'text-dark' : 'text-white'} ref={searchResultsRef} style={{ position: 'relative' }}>
        {/* Full-screen overlay while a visual is being created */}
        {isLocallyUploading && (
          <div style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0, 0, 0, 0.65)',
            backdropFilter: 'blur(3px)',
            WebkitBackdropFilter: 'blur(3px)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1rem',
          }}>
            <Spinner animation="border" style={{ width: '3rem', height: '3rem', color: '#60a5fa', borderWidth: '3px' }}>
              <span className="visually-hidden">Creating visual...</span>
            </Spinner>
            <p style={{ color: '#e2e8f0', fontSize: '1.1rem', fontWeight: 600, margin: 0 }}>
              Creating your visual…
            </p>
            <p style={{ color: '#94a3b8', fontSize: '0.88rem', margin: 0 }}>
              This may take a moment. Please don't navigate away.
            </p>
          </div>
        )}

        {blurb ? (
          <div className="mb-4 p-3 rounded" style={{backgroundColor: props.lightTheme ? "rgba(0,0,0,0.05)" : "rgba(255, 255, 255, 0.1)"}}>
            <p className="mb-0" style={{ fontSize: "1.1rem" }}>{blurb}</p>
          </div>
        ) : null}
        {uploadCount > 0 ? <p>{uploadCount} visuals uploading</p> : null}
        {uploadResult.length > 0 ? (
          <UploadResultDisplay result={uploadResult[uploadResult.length - 1]} isOrg={props.isOrg}/>
        ) : null}
        <Row className="d-flex justify-content-center">
          {sources.res.map((item, index) => (
            <VisItem
              key={`${item.type}-${item.id || item.url || item.image}-${index}`}
              title={item.title}
              description={item.description}
              imgSrc={getThumbnail(item)}
              icon={getIcon(item)}
              iconTitle={getIconTitle(item)}
              addFcn={getAddFcn(item)}
              isOrg={props.isOrg}
              isOwner={item.is_own}
              lightTheme={props.lightTheme}
              disabled={props.onlyOneVisual && uploadCount > 0}
              onVisualAdded={props.onVisualAdded}
              setIsUploading={handleSetIsUploading}
              url={item.url || item.visualization_url || item.visual_url}
            />
          ))}
        </Row>
      </div>
    );
  };
  
  const SearchComponent = (props) => {
    const [searchTerm, setSearchTerm] = useState(props.initialSearchQuery || null);

    useEffect(() => {
      if (props.initialSearchQuery) {
        setSearchTerm(props.initialSearchQuery);
      }
    }, [props.initialSearchQuery]);
  
    return (
      <>
        <SearchForm onSearch={setSearchTerm} searchTerm={searchTerm} />
        {searchTerm ? <SearchResults searchTerm={searchTerm} {...props} /> : null}
      </>
    );
  };
  
  export default SearchComponent; 